import { gql } from "@apollo/client";

export const GET_HISTORIAL_EVOLUCION_ASISTENCIAL = gql`
    query GetHistorialRIById($idEvaluacion: Int!) {
        historialRIById(idEvaluacion: $idEvaluacion) {
            idHistorialRI
            idEvaluacion
            idHistorialRITipoNavigation {
                nombre
            }
            idUsuarioNavigation {
                nombre
                apellido
            }
            fecha
            idEstado
            motivo
        }
    }
`;

export const adaptHistorialRI = (registro) => {
  return {
    idHistorialRI: registro?.idHistorialRI,
    idEvaluacion: registro?.idEvaluacion,
    evento: registro?.idHistorialRITipoNavigation?.nombre,
    usuario: registro?.idUsuarioNavigation?.apellido + ' ' + registro?.idUsuarioNavigation?.nombre,
    fechaRealizacion: registro?.fecha,
    idEstado: registro?.idEstado,
    descripcion: registro?.motivo
  };
};

export const adaptHistorialRIArray = (
registros) =>
{
  return structuredClone(registros)?.
  map((registro) => adaptHistorialRI(registro));
};